import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "results", "loading"]
  static values = { url: String }

  connect() {
    this.searchTimeout = null
    document.addEventListener('click', this.handleOutsideClick.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this))
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  }

  search(event) {
    const query = event.target.value.trim()
    
    // Clear user_id if input is empty
    if (!query) {
      this.hiddenTarget.value = ""
    }
    
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }

    if (query.length < 2) {
      this.hideResults()
      return
    }

    this.showLoading(true)
    
    this.searchTimeout = setTimeout(async () => {
      await this.performSearch(query)
    }, 300) // Debounce for 300ms
  }

  async performSearch(query) {
    try {
      const url = `${this.urlValue}?q=${encodeURIComponent(query)}`
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })

      if (response.ok) {
        const users = await response.json()
        this.displayResults(users)
      } else {
        console.error('Failed to search users:', response.statusText)
        this.hideResults()
      }
    } catch (error) {
      console.error('Error searching users:', error)
      this.hideResults()
    } finally {
      this.showLoading(false)
    }
  }

  displayResults(users) {
    this.resultsTarget.innerHTML = ''
    
    if (users.length === 0) {
      const noResults = document.createElement('div')
      noResults.className = 'px-4 py-3 text-sm text-slate-500 dark:text-slate-400'
      noResults.textContent = 'No users found'
      this.resultsTarget.appendChild(noResults)
    } else {
      users.forEach(user => {
        const option = document.createElement('div')
        option.className = 'px-4 py-3 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-600 text-sm border-b border-slate-200 dark:border-slate-600 last:border-b-0'
        option.innerHTML = `
          <div class="font-medium text-slate-900 dark:text-white">${user.name}</div>
          <div class="text-slate-500 dark:text-slate-400">${user.email}</div>
        `
        option.addEventListener('click', () => this.selectUser(user))
        this.resultsTarget.appendChild(option)
      })
    }
    
    this.showResults()
  }

  selectUser(user) {
    this.hiddenTarget.value = user.id
    this.inputTarget.value = `${user.name} (${user.email})`
    this.hideResults()
  }

  showResults() {
    this.resultsTarget.classList.remove('hidden')
  }

  hideResults() {
    this.resultsTarget.classList.add('hidden')
  }

  showLoading(show) {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.toggle('hidden', !show)
    }
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }
}
